import React, { useState } from "react";
import { Layout, Grid, Drawer, Button } from "antd";
import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { useSelector } from "react-redux";
import { selectAuthInfo } from "../pages/Auth/authSelectors";
import TriacHeader from "../components/Header";
import './MainLayout.scss'
import RightSidebar from "../components/RightSidebar";
import ChatAgent from "../components/ChatAgent/ChatAgent";
import CrmTaskReminder from "../components/CrmTaskReminder/CrmTaskReminder";
import { hasChatAccess } from "../lib/workflowAccess";
const {  Content, Sider } = Layout;
const { useBreakpoint } = Grid;

const MainLayout = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const authInfo = useSelector(selectAuthInfo);
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [rightbarVisible, setRightbarVisible] = useState(false);
  const screens = useBreakpoint();

  const MOBILE_HEADER_BASE = 80; //was 65
 
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }  
  return (

    <Layout style={{ minHeight: "100vh"}}>
  {screens.md && (
    <Sider
      collapsible
      collapsed={collapsed}
      width={200}
      collapsedWidth={80}
      trigger={null} // hide default trigger, since you use header button
      style={{
        transition: "width 0.3s ease, min-width 0.3s ease, max-width 0.3s ease",
        overflow: "hidden", // prevents content jumping
        position: "fixed", // keeps sidebar fixed
        background: "#001529",
        left: 0,
        top: 0,
        bottom: 0,
      }}
    >
      <Sidebar onItemClick={() => setDrawerVisible(false)} collapsed={collapsed}/>
    </Sider>
  )}
  {!screens.md && (
    <Drawer
      placement="left"
      closable={false}
      onClose={() => setDrawerVisible(false)}
      open={drawerVisible}
      width="60%"
      style={{ background: "#001529" }}
    >
      <Sidebar onItemClick={() => setDrawerVisible(false)} collapsed={collapsed}/>
    </Drawer>
  )}

  <Layout style={{ marginLeft: screens.md ? (collapsed ? 80 : 200) : 0 ,
                   transition: "margin-left 0.3s ease",
                   minHeight: "100vh",
  }}>
    <TriacHeader
      collapsed={collapsed}
      setCollapsed={setCollapsed}
      drawerVisible={drawerVisible}
      setDrawerVisible={setDrawerVisible}
      setRightbarVisible={setRightbarVisible}
      // setCollapsed={(value) => {
      //   setCollapsed(!value);
      //   setDrawerVisible(true);
      // }}
    />
    <Content style={{
      padding: "24px",
      paddingTop: screens.xs
      ? `calc(${MOBILE_HEADER_BASE}px + env(safe-area-inset-top) + 16px)`
      : "calc(80px + env(safe-area-inset-top))",
      paddingBottom: screens.xs
        ? hasChatAccess(authInfo)
          // Reserve room for the fixed chat-fab bubble (52px + 20px offset)
          // so it never sits on top of the last row of page content, e.g.
          // a form's Back/Reset/Save buttons.
          ? "calc(96px + env(safe-area-inset-bottom))"
          : "calc(24px + env(safe-area-inset-bottom))"
        : undefined,
      background: "#fff", minHeight: "100vh",
      transition: "all 0.3s ease"
      }}>
      <Outlet />
    </Content>
    <RightSidebar open={rightbarVisible} onClose={() => setRightbarVisible(false)} />
    {hasChatAccess(authInfo) && <ChatAgent />}
    <CrmTaskReminder />
  </Layout>
</Layout>

  );
};

export default MainLayout;
